import { useEffect, useState } from "react";
import EasyTable from "../../components/EasyTable";
import { EVENT, USER } from "../../admin_pages/api";
import EasyPagination from "../../components/EasyPagination";
import Modal from "../../components/modal";
import FormFactory from "../../components/FormFactory";
import { DEFAULT } from "../../api";
import { id } from "date-fns/locale";
import { format } from "date-fns";

export default function AdminEventsPage() {
	const [page, setPage] = useState({
		page: 1,
		perPage: 50,
	});
	const [data, setData] = useState([]);
	const [count, setCount] = useState(0);

	const [modal, setModal] = useState("update"); // 'add', 'edit', 'delete'
	const [selected, setSelected] = useState<any>(null);
	const [serviceConfig, setServiceConfig] = useState<any>(null);

	useEffect(() => {
		DEFAULT.getServiceConfig().then(setServiceConfig);
	}, []);

	useEffect(() => {
		getData();
	}, [page]);

	const columns = [
		{
			header: "ID",
			key: "id",
		},
		{
			header: "제목",
			key: "title",
		},
		{
			header: "카테고리",
			key: "category",
		},
		{
			header: "내용",
			key: "content",
			render: (v: string) => `${v?.slice(0, 10)}...`,
		},
		{
			header: "result",
			key: "result",
		},
		{
			header: "시작날짜",
			key: "startedAt",
			render: (v: string) => format(new Date(v), "yyyy-MM-dd"),
		},
		{
			header: "종료날짜",
			key: "endedAt",
			render: (v: string) => format(new Date(v), "yyyy-MM-dd"),
		},
		{
			header: "이미지",
			key: "imageFile",
			render: (v: any) => (
				<a target="_blank" className="text-blue-500" href={v.url}>
					{v.url}
				</a>
			),
		},
		{
			header: "삭제여부",
			key: "deletedAt",
		},
		{
			header: "수정",
			key: "edit",
			render: (value: any, row: any, index: any) => (
				<button onClick={() => handleUpdateModal(value, row, index)} className="border border-gray-600 bg-gray-200 px-3 py-1 rounded-sm font-normal text-sm">
					수정
				</button>
			),
		},
		{
			header: "삭제",
			key: "delete",
			render: (value: any, row: any) => (
				<button onClick={() => handleDelete(row.id)} className="border border-gray-600 bg-gray-200 px-3 py-1 rounded-sm font-normal text-sm">
					삭제
				</button>
			),
		},
	];

	const schema = [];

	const handleUpdateModal = (value: any, row: any, index: any) => {
		setModal("update");
		setSelected(row);
	};

	const getData = async () => {
		const response = await EVENT.pagination(page.page, page.perPage);

		setData(response.nodes);
		setCount(response.total);
	};

	const handleDelete = async (id: number) => {
		await EVENT.delete(id);
		getData();
	};

	const handleCreate = async (data: any) => {
		await EVENT.create({
			...data,
			imageFileId: data.imageFileId.id,
		});
		setModal("");
		getData();
	};

	const handleUpdate = async (data: any) => {
		await EVENT.update(selected.id, {
			...data,
			imageFileId: data.imageFileId.id,
		});
		setSelected(null);
		setModal("");
		getData();
	};

	return (
		<div>
			<h1>이벤트 관리</h1>
			<div className="flex justify-end">
				<button onClick={() => setModal("add")} className="border border-gray-600 bg-gray-200 px-3 py-1 rounded-sm font-normal text-sm">
					추가
				</button>
			</div>
			<div>
				<div className="mt-4 w-full overflow-x-scroll">
					<EasyTable data={data} columns={columns} />
				</div>

				<div className="mt-4">
					<EasyPagination
						{...page}
						count={count}
						onChange={(_page) =>
							setPage({
								...page,
								page: _page,
							})
						}
					/>
				</div>

				<Modal open={modal === "add"} onClose={() => setModal("")} size="lg">
					<div>추가</div>
					<div>
						<FormFactory
							schema={[
								{ label: "제목", key: "title", method: "text", validation: "required" },
								{ label: "카테고리", key: "category", method: "text", validation: "required" },
								{ label: "내용", key: "content", method: "textarea", validation: "required" },
								{ label: "url", key: "url", method: "text" },
								{ label: "시작 날짜", key: "startedAt", method: "date", validation: "required" },
								{ label: "종료 날짜", key: "endedAt", method: "date", validation: "required" },
								{ label: "이미지", key: "imageFileId", method: "file", validation: "required" },
							]}
							onSubmit={handleCreate}
						/>
					</div>
				</Modal>

				{selected && (
					<Modal open={modal === "update"} onClose={() => setModal("")} size="lg">
						<div className="mb-6">수정</div>

						<FormFactory
							schema={[
								{ label: "제목", key: "title", method: "text", validation: "required", defaultValue: selected.title },
								{ label: "카테고리", key: "category", method: "text", validation: "required", defaultValue: selected.category },
								{ label: "내용", key: "content", method: "textarea", validation: "required", defaultValue: selected.content },
								{ label: "url", key: "url", method: "text", defaultValue: selected.url },
								{
									label: "시작 날짜",
									key: "startedAt",
									method: "date",
									validation: "required",
									defaultValue: format(new Date(selected.startedAt), "yyyy-MM-dd"),
								},
								{ label: "종료 날짜", key: "endedAt", method: "date", validation: "required", defaultValue: format(new Date(selected.endedAt), "yyyy-MM-dd") },
								{ label: "이미지", key: "imageFileId", method: "file", validation: "required", defaultValue: selected.imageFile },
							]}
							onSubmit={handleUpdate}
						/>
					</Modal>
				)}
			</div>
		</div>
	);
}
